<div class="home-tab-container">
  <div class="contact-details-container" *ngIf="merchant !== null && merchant.phones.isNotEmpty()">
    <p class="contact-details-title" i18n="@@contactDetails">Contact Details</p>
    <div class="contact-details-info">
      <div class="contact-details-number-container" *ngFor="let merchantContact of merchant?.phones">
        <p class="contact-details-number">+{{ merchantContact.countryCode }}{{ merchantContact.phoneNumber }}</p>
<!--        <img [src]="hasTelegramIcon(merchantContact)" alt="telegram">-->
<!--        <img [src]="hasWhatsappIcon(merchantContact)" alt="Whatsapp">-->
        <img src= "assets/telegram-icon.svg" *ngIf="hasTelegramIcon(merchantContact)" alt="telegram">
        <img src= "assets/whats-app-icon.svg" *ngIf="hasWhatsappIcon(merchantContact)" alt="Whatsapp">
      </div>
    </div>
  </div>

  <div class="about-us-container" *ngIf="merchantBriefExists()">
    <div class="about-us-title" i18n="@@about">About</div>
<!--    <div class="location-info">Cairo, Egypt</div>-->
    <div class="about-us-desc">
      {{ merchant?.brief }}
    </div>
    <div class="tax-number" *ngIf="merchant !== null && merchant?.taxIdentificationNumber?.hasActualValue()">
      <p i18n="@@taxNumber">Tax number: {{merchant.taxIdentificationNumber}}</p>
    </div>
    <div class="social-media-platforms" *ngIf="merchantMediaExists()">
      <div *ngFor="let socialMediaPlatform of merchant?.socialMediaPlatforms">
        <div (click)="openPlatform(socialMediaPlatform)">
          <img [src]="getSocialMediaIcon(socialMediaPlatform)"/>
        </div>
      </div>
    </div>
  </div>

  <div class="top-products-container" *ngIf="products.isNotEmpty()">
    <p class="contact-details-title" i18n="@@topSales">Top Sales 🔥</p>
    <div class="top-product-items-container">
      <div *ngFor="let product of products">
        <product-item [product]="product"></product-item>
      </div>
    </div>
    <div class="text-center">
      <button class="button-primary all-menu-button" (click)="openMenuTab()" *ngIf="products.isNotEmpty()" i18n="@@allMenu">All Menu</button>
    </div>
  </div>

  <div class="empty-state" *ngIf="products.isEmpty() && (merchant?.brief === null || merchant?.brief === undefined) && merchant?.phones!.isEmpty()">
    <div><img src="assets/home-empty-state.svg"></div>
    <div class="empty-state-title">
      <p i18n="@@merchantHomeTabEmptyLabel">There is no info available yet!</p>
    </div>
    <div class="empty-state-message">
      <p i18n="@@emptyTabsMessage">Be the first to share your experience!</p>
    </div>
  </div>
</div>
